import { useQuery, UseQueryOptions } from 'react-query';
import { LiveEventType } from 'api-data-types';
import moment from 'moment';
import requester from 'utils/requester';
import api from 'config/api';

const key = 'EPG';

const DEFAULT_OPTIONS = {};

type LoadType = { channelIds: number[] };

const load = async ({ channelIds }: LoadType) => {
  const now = Date.now();
  const startTime = moment(now).subtract(4, 'hour').toISOString();
  const endTime = moment(now).add(4, 'hour').toISOString();

  const { data } = await requester({
    method: 'get',
    url: `${api.host}${api.endpoints.liveEvents}`,
    params: {
      'live.id[in]': channelIds.join(','),
      $expand: 'thumbnail(url),program,dvr,live',
      'start_time[gt]': startTime,
      'end_time[lt]': endTime,
    },
  });
  return data;
};

const useLoadEpg = (
  params: LoadType,
  options: UseQueryOptions<LiveEventType[], unknown, LiveEventType[]> = {},
) => {
  return useQuery<LiveEventType[], Error>([key], () => load(params), {
    ...DEFAULT_OPTIONS,
    ...options,
  });
};

export default useLoadEpg;
